import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const ImportacoesRotas = (): RouteRecordRaw[] => [
  {
    path: "/importacoes",
    name: "Importações",
    meta: {
      titulo: t("tituloDaRotaDeImportacoes"),
      regras: ["auth", "cancelador"],
      modulo: "Importacoes",
      operador: "ou",
      permissoes: ["criar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Importacoes" */
        "@/paginas/Importacoes/Importacoes.vue"
      ),
  },
]
